// Configuration automatique de l'URL backend
// Utilise la variable d'env si disponible, sinon utilise l'origine actuelle
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;
export const API = `${BACKEND_URL}/api`;

console.log('[Config] Backend URL:', BACKEND_URL);
console.log('[Config] API URL:', API);
